import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdaptiveContainerService, AdaptiveDialogRef } from '../../adaptive-container/adaptive-container.service';

export interface AlertModalData {
  title: string;
  message: string;
  /**Defaults to "Confirm"*/
  buttonText?: string;
}

/**Open with AlertModalComponent.open()*/
@Component({
  selector: 'alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrl: './alert-modal.component.css'
})
export class AlertModalComponent {

  /**Returns the ref so callers can close it from code or wait on afterClosed()*/
  public static open(adaptive: AdaptiveContainerService, title: string, message: string, buttonText: string = 'Confirm',
    options?: { disableClose?: boolean }): AdaptiveDialogRef<AlertModalComponent, void> {
    return adaptive.open<AlertModalComponent, AlertModalData, void>(AlertModalComponent, {
      width: '300px',
      disableClose: options?.disableClose,
      data: { title, message, buttonText }
    });
  }

  public title: string;
  public message: string;
  public buttonText: string;

  constructor(public dialogRef: MatDialogRef<AlertModalComponent>, @Inject(MAT_DIALOG_DATA) data: AlertModalData) {
    this.title = data.title;
    this.message = data.message;
    this.buttonText = data.buttonText ?? 'Confirm';
  }

  public dismiss() {
    this.dialogRef.close();
  }

}
